export default __webpack_public_path__ + "static/media/368.60f521dd.png";